import React from 'react'
import * as ReactDOM from 'react-dom'
import { Typography, withStyles, withWidth } from '@material-ui/core'
import { scrollToTop } from './ArticlePointMapSegment'
import FormLabel from '@material-ui/core/FormLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import { Player } from 'video-react'
import 'video-react/dist/video-react.css'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio' // import css

export const ACTIVE_LISTENING = 'ACTIVE_LISTENING'

const styles = theme => ({
  caption: {
    margin: 20,
  },
  pointsBackground: {
    margin: '0 auto',
    flex: 1
  },
  pyramidContainer: {
    display: 'flex',
    maxWidth: 1260
  },
  pyramidImage: {
    width: '50%',
    maxWidth: 630,
    minHeight: 1200

  },
  pyramidSvgContainer: {
    height: 170,
  },
  pyramidChoices: {
    width: '50%',
    maxWidth: 630
  },
  sortableList: {},

  sortableItem: {
    margin: '10px',
    textAlign: 'justify',
    paddingLeft: 5,
    borderLeft: 'black solid',
    minHeight: 160
  },
  SortableItemHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    // margin: 5,
    padding: 3,
    textTransform: 'uppercase'
  },
  svg: {
    width: '100%',
    display: 'block',
    backgroundColor: '#EDEDED',
  },
  polygon: {
    fill: theme.palette.common.white,
    // fill: 'grey',
    stroke: theme.palette.divider,
    strokeWidth: 1,
  },
  svgText: {
    backgroundColor: '#F90000',
    color: 'white'
  },
  pyramidHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    display: 'block',
    position: 'relative',
    padding: 5,
    textAlign: 'center'
  },
  symbolsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    // width: '50%'
  },
  symbolCard: {
    borderStyle: 'solid',
    borderWidth: 26,
    borderColor: 'brown',
    width: 300,
    height: 450,
    margin: 5,
    alignContent: 'center',
    position: 'relative',
  },
  symbolCardImage: {
    width: '100%',
    top: '50%',
    transform: 'translate(0%,-50%)',
    position: 'absolute',
    // margin: '0 5%'
    padding: '5%'
  },
  symbolCardText: {
    textAlign: 'center',
    padding: 10,
    top: '50%',
    transform: 'translate(0%,-50%)',
    position: 'absolute',
  },
  draggableText: {
    margin: 3
  },
  dropTarget: {
    // backgroundColor: 'green',
  },
  barometerAgree: {},
  barometerAgreeQuestion: {
    width: '100%',
    marginTop: 40
  },
  barometerGauge: {
    maxWidth: 600,
    margin: '0 auto'
  },
  formsetRow: {
    // justifyContent: 'space-around'
    // flexDirection: 'column',
  },
  error: {
    color: 'red'
  },
  newspaper: {
    maxHeight: '70vh'
  },
  newspaperContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    /* align-content: center, */
    alignItems: 'center',
  },
  questionsContainer: {
    padding: 20,
    maxWidth: 800,
    margin: '0 auto'
  }
})

const barometer_questions = [
  {
    statements: [
      'CORRECT SENTENCE FROM THE VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
    ],
    right: 0,
    title: 'PARAPHRASING/SUMMARIZING',
    positive: true,
    text: 'Active listener repeats after the speaker in their own words to make sure that they ' +
      'understand the message and to show that they pay attention and not only listen but also hear.'
  },
  {
    statements: [
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'CORRECT SENTENCE FROM THE VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
    ],
    right: 1,
    title: 'ASKING OPEN-ENDED QUESTIONS',
    positive: true,
    text: ' to assist the other person to further develop their thoughts, feelings, fears, questions.'
  },

  {
    statements: [
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'CORRECT SENTENCE FROM THE VIDEO',
    ],
    right: 2,
    title: 'JUMPING TO CONCLUSIONS',
    positive: false,
    text: ' and putting words into the mouth of the other person is not a technique of active listening.'
  },
  {
    statements: [
      'CORRECT SENTENCE FROM THE VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
    ],
    right: 0,
    title: 'JUDGING AND SHAMING THE OTHER PERSON FOR THEIR DECISIONS, OPINIONS, STATEMENTS',
    positive: false,
    text: 'is not a technique of active listening'
  },
  {
    statements: [
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'CORRECT SENTENCE FROM THE VIDEO',
    ],
    right: 2,
    title: 'EXPRESSING EMPATHY',
    positive: true,
    text: 'validating (negative) feelings of the other person; accepting the emotions and expressed ' +
      'concerns rather than questioning the speaker’s actions. The listener’s opinions are not of primary ' +
      'importance.'
  },
  {
    statements: [
      'CORRECT SENTENCE FROM THE VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
    ],
    right: 0,
    title: 'TAKING TURNS:',
    positive: true,
    text: 'after the speaker made the statement and the listener had engaged in the active listening ' +
      'steps described above, the speaker can share their perspectives and opinions.'
  },
  {
    statements: [
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'CORRECT SENTENCE FROM THE VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
    ],
    right: 1,
    title: 'DISENGAGED BODY LANGUAGE:',
    positive: false,
    text: ' not making eye contact, anxious body posture, attending to distractions (checking the phone, ' +
      'changing the subject of conversation etc.), showing disapproval and disgust is not technique of ' +
      'active listening.'
  },
  {
    statements: [
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'CORRECT SENTENCE FROM THE VIDEO',
    ],
    right: 2,
    title: 'MENTIONING SIMILAR SITUATIONS',
    positive: true,
    text: 'to build a connection between the speaker and listener and to build equalized power' +
      ' positions (being exposed and equally vulnerable)'
  },
  {
    statements: [
      'CORRECT SENTENCE FROM THE VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
      'WRONG ADJUSTED SENTENCE FROM VIDEO',
    ],
    right: 0,
    title: 'VERBAL AND BODY AFFIRMATION',
    positive: true,
    text: ' listeners shows and confirms verbally that they appreciate the speaker’s trust and ' +
      'courage to share'
  }
]

class ActiveListeningSegment extends React.Component {
  state = {
    movieFinished: false,
    currentQuestion: 0,
    correct: false,
    currentArea: null,
    answers: [],
    avgAnswer: null,
    player: null,
    error: false
  }

  componentDidMount () {
    let answers = []
    for (let i = 0; i < barometer_questions.length; i++) {
      answers.push({ value: undefined })
    }
    this.setState({ answers })

    let rect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
    setTimeout(() => scrollToTop(this), 500)
    if (!this.boundingRect) {
      this.boundingRect = rect
      this.forceUpdate()
    } else {
      this.boundingRect = rect
    }
    this.player.subscribeToStateChange(this.handleStateChange.bind(this))
  }

  handleStateChange (state, prevState) {
    // copy player state to this component's state
    this.setState({
      player: state,
      movieFinished: state.ended
    })
  }

  isFinished () {
    let i = this.state.currentQuestion

    if (this.state.answers[i].value === barometer_questions[i].right) {
      this.setState({ currentQuestion: ++i, error: false })
    } else {
      this.setState({ error: true })
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.boundingRect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
  }

  checkCorrect () {
    return true
  }

  handleChange (index) {
    return (event) => {
      let answers = this.state.answers
      console.log(event.target.value, index, answers[index])
      answers[index].value = parseInt(event.target.value, 10)

      this.setState({ answers })
      this.isFinished()
    }
  }

  render () {
    let {
      className, classes
    } = this.props
    let { currentQuestion, movieFinished } = this.state
    let question = barometer_questions[currentQuestion]

    return <div className={className}>
      <div className={classes.newspaperContainer}>
        <Player
          playsInline
          ref={(player) => { this.player = player }}
          // poster="/assets/poster.png"
          // src="/upload/active_listening/active_listening_movie.mp4"

          // TODO remove autoplay
          src="https://againneveragain.eu/upload/active_listening/active_listening_movie.mp4"
          // startTime={193}
          // autoPlay={true}
        />
      </div>
      {movieFinished &&
      <div className={classes.questionsContainer}>
        <div>
        </div>
        {barometer_questions.map((item, index) => {
          if (index < currentQuestion) {
            return <div key={index}>
              <Typography variant={'h1'}>
                {item.title}
              </Typography>
              <Typography>
                {item.text}
              </Typography>
              <hr/>
            </div>
          } else {
            return ''
          }
        })}
        {currentQuestion < barometer_questions.length &&
        <FormControl component="fieldset" className={classes.barometerAgreeQuestion}>
          <FormLabel>
            <div>
              <Typography variant="h4">
                Choose the answer that appeared in the video.
              </Typography>
              {this.state.error && <Typography variant="h5" className={classes.error}>
                This is not the correct statement choose another
              </Typography>}
            </div>
          </FormLabel>
          <RadioGroup
            aria-label="position"
            name="position"
            // value={this.state.answers[currentQuestion].value}
            onChange={this.handleChange(currentQuestion)}
            className={classes.formsetRow}
          >
            {question.statements.map((statement, statementIndex) => {
              return <FormControlLabel
                key={statementIndex}
                value={statementIndex.toString()}
                control={<Radio color="primary"/>}
                label={statement}
                labelPlacement="end"
              />
            })}
          </RadioGroup>
        </FormControl>
        }
      </div>
      }
    </div>
  }
}

export default withWidth()(withStyles(styles, { withTheme: true })(
  ActiveListeningSegment
))
